export const MEMBERS_BASE_PATH = `${import.meta.env.VITE_API_HOST}/members/api/v1`;

export const API = {
  SUBSCRIPTION_FINALIZE: `${MEMBERS_BASE_PATH}/subscription/finalize`,
};
